import React from 'react';
import '../css/talent.css';
import { ArrowRightIcon } from '../../../../../assets-module/asset-configuration/icon/iconExporter/iconExporter';
import RoundButton from '../../../button/round-button/ts/roundButton';

export interface TalentStep {
  id: string;
  step: string;
  title: string;
  description: string;
  hasButton?: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
}

interface TalentListProps {
  steps: TalentStep[];
  className?: string;
}

const TalentList: React.FC<TalentListProps> = ({ steps, className = '' }) => {
  return (
    <div className={`scl--web-component-talent-list-container ${className}`}>
      {steps.map((step) => (
        <div key={step.id} className="scl--web-component-talent-step-item">
          <div className="scl--web-component-talent-step-number">{step.step}</div>

          <div className="scl--web-component-talent-content">
            <div className="scl--web-component-talent-title">{step.title}</div>
            <div className="scl--web-component-talent-description">{step.description}</div>

            {step.hasButton && (
              <RoundButton
                className="scl--web-component-talent-button"
                onClick={step.onButtonClick}
              >
                <span className="scl--web-component-talent-button-text">
                  {step.buttonText || 'Apply'}
                </span>
                <ArrowRightIcon width={14} height={16} />
              </RoundButton>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TalentList;
